<template>
  <ul class="dianjin-list">
    <li v-for="(item, index) in list" :key="index" class="dianjin">
      <div class="dianjin-inline">
        <router-link
          class="dianjin-pic"
          :style="{
            backgroundImage: `url(${item.dianJinInfo.coverImageUrl})`
          }"
          :to="`/dianjin/${item.dianJinInfo.id}`"
        >
          <div
            v-show="item.dianJinInfo.type == 1"
            class="dianjin-play-icon"
          ></div>
        </router-link>
        <div class="dianjin-right">
          <div class="title-all">
            <router-link
              class="dianjin-title"
              :to="`/dianjin/${item.dianJinInfo.id}`"
              >{{ item.authorInfo.name + ' : ' + item.dianJinInfo.title }}
            </router-link>
            <div
              class="lock-icon"
              v-if="
                !item.dianJinInfo.isFree &&
                  !hasRight(item.dianJinInfo.productId)
              "
            ></div>
            <div
              class="unlock-icon"
              v-if="
                !item.dianJinInfo.isFree && hasRight(item.dianJinInfo.productId)
              "
            ></div>
          </div>
          <div class="dianjin-author" v-if="showAuthor">
            <router-link
              class="head"
              :style="{
                backgroundImage: `url(${item.authorInfo.headPic})`
              }"
              :to="`/author/${item.authorInfo.authorId}`"
            ></router-link>
            <div class="author-name">{{ item.authorInfo.name }}</div>
            <div class="author-type-company">
              {{ item.authorInfo.typeName }}
              {{ item.authorInfo.authorCompany ? '|' : '' }}
              {{ item.authorInfo.authorCompany }}
            </div>
          </div>
          <div class="dianjin-date">
            {{ item.dianJinInfo.publishTimeDesc }}
          </div>
          <router-link
            class="dianjin-comment"
            :to="`/dianjin/${item.dianJinInfo.id}`"
          >
            <div class="comment-icon"></div>
            <div class="comment-number">
              {{ item.dianJinInfo.commentsCount }}
            </div>
          </router-link>
          <!-- <router-link
                      class="dianjin-comment"
                      :to="`/comment/${item.dianJinInfo.id}`"
                    > -->
          <!-- </router-link> -->
        </div>
      </div>
    </li>
    <li v-show="!end" class="more" @click="loadMore">点击查看更多</li>
  </ul>
</template>

<script>
export default {
  name: 'DianLinList',
  props: {
    list: {
      type: Array,
      required: true
    },
    end: {
      type: Boolean,
      default: true
    },
    showAuthor: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    userDianJinRights() {
      return this.$store.state.right.allRightList == null
        ? null
        : this.$store.state.right.allRightList.filter(
          item => item.rightType === 4
        )
    }
  },
  methods: {
    hasRight(id) {
      return this.userDianJinRights == null
        ? false
        : this.userDianJinRights.filter(e => e.productId === id).length > 0
    },
    loadMore() {
      this.$emit('loadMore')
    }
  }
}
</script>

<style lang="scss" scoped>
.dianjin-list {
  display: flex;
  flex-direction: column;
}
.dianjin {
  height: 160px;
}
.dianjin-inline {
  padding-top: 20px;
  padding-bottom: 20px;
  display: flex;
  flex-direction: row;
  position: relative;
}
.dianjin-pic {
  width: 160px;
  height: 120px;
  background: no-repeat center;
  background-size: cover;
  cursor: pointer;
}
.dianjin-right {
  margin-left: 20px;
  flex: auto;
  display: flex;
  flex-direction: column;
  position: relative;
  align-content: space-between;
}
.dianjin-title {
  font-size: 20px;
  line-height: 40px;
  font-weight: normal;
  font-stretch: normal;
  color: #262626;
  transition: color 0.3s;
  cursor: pointer;
  text-decoration: none;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 645px;
  display: inline-block;
}

.dianjin-date {
  position: absolute;
  bottom: 9px;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 24px;
  letter-spacing: 1px;
  color: #858585;
}
.dianjin-comment {
  display: flex;
  position: absolute;
  align-items: center;
  bottom: 9px;
  right: 5px;
  text-decoration: none;
}
.dianjin-author {
  display: flex;
  flex-direction: row;
  margin-top: 5px;
}

.head {
  width: 24px;
  height: 24px;
  background: no-repeat center;
  background-size: cover;
  border-radius: 50%;
  cursor: pointer;
}

.author-name {
  padding-left: 10px;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 25px;
  letter-spacing: 1px;
  color: #858585;
}
.author-type-company {
  padding-left: 15px;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 25px;
  letter-spacing: 1px;
  color: #858585;
}

.comment-icon {
  width: 16px;
  height: 14px;
  background: url('~@/assets/images/author/comment_icon.png') no-repeat center;
  background-size: cover;
  margin-right: 5px;
}

.dianjin-play-icon {
  width: 80px;
  height: 80px;
  position: absolute;
  left: 45px;
  top: 37px;
  background: url('~@/assets/images/dianjin/dianjin-list-icon.png') no-repeat
    center;
}

.lock-icon {
  width: 17px;
  height: 20px;
  display: inline-block;
  background: url('~@/assets/images/icons/lock.png') no-repeat center;
  background-size: cover;
  vertical-align: text-top;
  margin-left: 10px;
}

.unlock-icon {
  width: 17px;
  height: 20px;
  display: inline-block;
  background: url('~@/assets/images/icons/unlock.png') no-repeat center;
  background-size: cover;
  vertical-align: text-top;
  margin-left: 10px;
}
.comment-number {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 24px;
  letter-spacing: 1px;
  color: #858585;
}

.more {
  width: 828px;
  height: 40px;
  margin: 30px auto;
  font-size: 14px;
  line-height: 40px;
  color: #858585;
  background-color: #fafafa;
  text-align: center;
  cursor: pointer;
}
</style>
